import { render, staticRenderFns } from "./StandaloneLive.vue?vue&type=template&id=6d7fb79c&scoped=true"
import script from "./StandaloneLive.vue?vue&type=script&lang=js"
export * from "./StandaloneLive.vue?vue&type=script&lang=js"
import style0 from "./StandaloneLive.vue?vue&type=style&index=0&id=6d7fb79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7fb79c",
  null
  
)

export default component.exports